export function printHtmlDocument(html: string): void {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  Object.assign(iframe.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0', visibility: 'hidden' });
  document.body.appendChild(iframe);
  const cleanup = () => iframe.parentNode?.removeChild(iframe);
  iframe.addEventListener('load', () => {
    const frameWindow = iframe.contentWindow;
    if (!frameWindow) return cleanup();
    try { frameWindow.focus(); frameWindow.print(); }
    finally { setTimeout(cleanup, 500); }
  }, { once: true });
  const frameDocument = iframe.contentWindow?.document;
  if (!frameDocument) { cleanup(); return; }
  frameDocument.open(); frameDocument.write(html); frameDocument.close();
}